(() => {
  const initialize = (root) => {
    if (!root || root.dataset.faqReady === 'true') return;

    const input = root.querySelector('[data-faq-search]');
    const count = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('[data-faq-empty]');
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const modules = Array.from(root.querySelectorAll('[data-faq-module]'));

    if (!input || !count || !empty || !items.length) return;

    root.dataset.faqReady = 'true';

    const filterFaq = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const matches = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.classList.toggle('is-hidden', !matches);
        if (matches) visibleCount += 1;
      });

      modules.forEach((module) => {
        const hasVisibleItem = module.querySelector('[data-faq-item]:not(.is-hidden)');
        module.classList.toggle('is-empty', !hasVisibleItem);
      });

      count.textContent = `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'}`;
      empty.hidden = visibleCount !== 0;
    };

    input.addEventListener('input', filterFaq);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        filterFaq();
      }
    });
  };

  const initializeAll = (container = document) => {
    container.querySelectorAll('[data-ink-faq]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
